// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C05 clauses and C06 proposal preview. Never scope rules over the sidebar. */
.agreement-editor-terms .agreement-clauses--structured,
.agreement-review-page .agreement-clauses--structured {
  gap: var(--space-5);
}
.agreement-editor-terms .agreement-clause,
.agreement-review-page .agreement-clause {
  display: grid;
  gap: var(--space-2);
}
.agreement-editor-terms .agreement-clause h3,
.agreement-review-page .agreement-clause h3 {
  margin: 0;
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
}
.agreement-editor-page .agreement-editor-terms .agreement-clause p {
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.agreement-review-page {
  max-width: 1440px;
}
.agreement-review-status {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.agreement-review-columns {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);
  align-items: start;
  gap: var(--space-6);
}
.agreement-review-document {
  min-width: 0;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  overflow: hidden;
}
.agreement-review-document-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  background: var(--surface-secondary);
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.agreement-review-document-bar strong {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
}
.agreement-review-document-bar svg {
  width: 20px;
  height: 20px;
  color: var(--text-secondary);
}
.agreement-review-paper {
  padding: var(--space-8);
  display: grid;
  gap: var(--space-6);
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
  overflow-wrap: anywhere;
}
.agreement-review-document-heading {
  display: grid;
  gap: var(--space-3);
  padding-bottom: var(--space-6);
  border-bottom: 1px solid var(--border-subtle);
}
.agreement-review-page .agreement-review-brand {
  color: var(--interactive-default);
  font-weight: var(--font-weight-medium);
}
.agreement-review-page .agreement-review-document-heading h2 {
  margin: 0;
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: -0.39px;
  font-weight: var(--font-weight-semibold);
}
.agreement-review-document-heading > p:last-child {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.agreement-review-parties {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-6);
}
.agreement-review-parties section {
  display: grid;
  align-content: start;
  gap: var(--space-2);
}
.agreement-review-page .agreement-review-parties h3 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.55px;
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  margin: 0;
}
.agreement-review-scope {
  display: grid;
  gap: var(--space-2);
  background: var(--surface-secondary);
  border-radius: var(--radius-md);
  padding: var(--space-4);
}
.agreement-review-acknowledgement {
  display: grid;
  gap: var(--space-3);
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-6);
}
.agreement-review-page .agreement-review-acknowledgement h3 {
  margin: 0;
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.agreement-review-acknowledgement .rcti-signature-image {
  width: 100%;
  max-height: 90px;
  object-fit: contain;
  object-position: left;
}
.agreement-review-pending {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-5);
  border-radius: var(--radius-md);
  background: var(--warning-soft);
}
.agreement-review-page .agreement-review-pending h3 {
  color: var(--warning-text);
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  margin: 0;
}
.agreement-review-page .agreement-review-muted {
  font-size: var(--font-size-caption-md);
  line-height: 1.5;
  color: var(--text-secondary);
}
.agreement-review-sidebar {
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.agreement-review-page .rcti-agreement-card h2 {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.agreement-review-page .rcti-agreement-card label {
  font-size: var(--font-size-body-sm);
}
.agreement-review-page input[readonly],
.agreement-review-page textarea[readonly] {
  background: var(--surface-primary);
  color: var(--text-primary);
}
.agreement-review-page textarea[readonly] {
  resize: none;
  line-height: 1.6;
}
.agreement-review-note {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: var(--font-size-caption-md);
  line-height: 1.5;
}
.agreement-review-page .agreement-review-before .rcti-consent {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  font-weight: var(--font-weight-regular);
}
.agreement-review-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-4);
  border-top: 1px solid var(--border-default);
  padding-top: var(--space-4);
}
@media (max-width: 1100px) {
  .agreement-review-columns {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .agreement-review-paper {
    padding: var(--space-5);
  }
  .agreement-review-page .agreement-review-document-heading h2 {
    font-size: 23px;
  }
  .agreement-review-parties {
    grid-template-columns: 1fr;
    gap: var(--space-5);
  }
  .agreement-review-footer > button {
    width: 100%;
  }
  .agreement-review-document-bar {
    flex-wrap: wrap;
  }
}
.agreement-review-paper .agreement-clause p,
.agreement-review-paper .agreement-review-scope p,
.agreement-review-acknowledgement > p:not(.agreement-review-muted),
.agreement-review-pending > p:first-of-type {
  color: var(--text-primary);
}
.agreement-review-acknowledgement .rcti-saved-signature img {
  max-height: 100px;
}
/* One formal agreement presentation for buyer preview and supplier records. */
.rcti-designed .rcti-agreement-document.agreement-contract-document {
  padding: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.agreement-contract-document .agreement-review-document-heading h2 {
  margin: 0;
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: -0.39px;
  font-weight: var(--font-weight-semibold);
}
.agreement-contract-document .agreement-review-brand {
  color: var(--interactive-default);
  font-weight: var(--font-weight-medium);
}
.agreement-contract-document .agreement-review-parties h3 {
  margin: 0;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.55px;
  color: var(--text-secondary);
}
.agreement-contract-document .agreement-review-muted {
  font-size: var(--font-size-caption-md);
  line-height: 1.5;
  color: var(--text-secondary);
}
.agreement-contract-document .agreement-review-acknowledgement h3 {
  margin: 0;
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.agreement-contract-document .agreement-review-pending h3 {
  margin: 0;
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  color: var(--warning-text);
}
.agreement-contract-document .agreement-contract-status {
  margin: 0;
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.agreement-review-email-card {
  display: grid;
  gap: var(--space-4);
  padding: var(--space-5);
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-agreements__content
  .agreement-review-email-card
  .agreement-email-preview-cta:disabled {
  justify-self: start;
  background: var(--interactive-disabled);
  color: var(--on-interactive-disabled);
  border: 1px solid var(--border-default);
  cursor: not-allowed;
  opacity: 1;
  box-shadow: none;
}
@media (max-width: 1100px) {
  .rcti-designed .agreement-public-workspace {
    grid-template-columns: 1fr;
  }
  .agreement-public-workspace > .rcti-agreement-document,
  .agreement-public-workspace > form,
  .agreement-public-workspace > .rcti-public-controls {
    grid-column: 1;
    grid-row: auto;
  }
}
@media (max-width: 600px) {
  .agreement-contract-document .agreement-review-document-heading h2 {
    font-size: 23px;
  }
}
@media print {
  .agreement-public-workspace {
    display: block !important;
  }
  .agreement-public-workspace > form,
  .agreement-public-workspace > .rcti-public-controls {
    display: none !important;
  }
  .agreement-contract-document {
    border: 0 !important;
  }
}
.agreement-contract-document .rcti-agreement-badge {
  justify-self: start;
}
.agreement-public-workspace > form > p,
.agreement-public-workspace > .rcti-public-controls p,
.rcti-agreements--public .rcti-design-heading p {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.agreement-signature-sections { display: contents; }
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/agreementReview.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;;EAEE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,sCAAsC;EACtC,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA,8EAA8E;AAC9E;EACE,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,sCAAsC;EACtC,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;EACnB,uCAAuC;EACvC,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;;;IAGE,cAAc;IACd,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mCAAmC;EACnC,gBAAgB;AAClB;AACA,gCAAgC,iBAAiB,EAAE","sourcesContent":["/* C05 clauses and C06 proposal preview. Never scope rules over the sidebar. */\n.agreement-editor-terms .agreement-clauses--structured,\n.agreement-review-page .agreement-clauses--structured {\n  gap: var(--space-5);\n}\n.agreement-editor-terms .agreement-clause,\n.agreement-review-page .agreement-clause {\n  display: grid;\n  gap: var(--space-2);\n}\n.agreement-editor-terms .agreement-clause h3,\n.agreement-review-page .agreement-clause h3 {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.5;\n}\n.agreement-editor-page .agreement-editor-terms .agreement-clause p {\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.agreement-review-page {\n  max-width: 1440px;\n}\n.agreement-review-status {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.agreement-review-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);\n  align-items: start;\n  gap: var(--space-6);\n}\n.agreement-review-document {\n  min-width: 0;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  overflow: hidden;\n}\n.agreement-review-document-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.agreement-review-document-bar strong {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  color: var(--text-primary);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-review-document-bar svg {\n  width: 20px;\n  height: 20px;\n  color: var(--text-secondary);\n}\n.agreement-review-paper {\n  padding: var(--space-8);\n  display: grid;\n  gap: var(--space-6);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n.agreement-review-document-heading {\n  display: grid;\n  gap: var(--space-3);\n  padding-bottom: var(--space-6);\n  border-bottom: 1px solid var(--border-subtle);\n}\n.agreement-review-page .agreement-review-brand {\n  color: var(--interactive-default);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-review-page .agreement-review-document-heading h2 {\n  margin: 0;\n  font-size: 26px;\n  line-height: 1.3;\n  letter-spacing: -0.39px;\n  font-weight: var(--font-weight-semibold);\n}\n.agreement-review-document-heading > p:last-child {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.agreement-review-parties {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-6);\n}\n.agreement-review-parties section {\n  display: grid;\n  align-content: start;\n  gap: var(--space-2);\n}\n.agreement-review-page .agreement-review-parties h3 {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.55px;\n  font-weight: var(--font-weight-medium);\n  color: var(--text-secondary);\n  margin: 0;\n}\n.agreement-review-scope {\n  display: grid;\n  gap: var(--space-2);\n  background: var(--surface-secondary);\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n}\n.agreement-review-acknowledgement {\n  display: grid;\n  gap: var(--space-3);\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-6);\n}\n.agreement-review-page .agreement-review-acknowledgement h3 {\n  margin: 0;\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-review-acknowledgement .rcti-signature-image {\n  width: 100%;\n  max-height: 90px;\n  object-fit: contain;\n  object-position: left;\n}\n.agreement-review-pending {\n  display: grid;\n  gap: var(--space-3);\n  padding: var(--space-5);\n  border-radius: var(--radius-md);\n  background: var(--warning-soft);\n}\n.agreement-review-page .agreement-review-pending h3 {\n  color: var(--warning-text);\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  margin: 0;\n}\n.agreement-review-page .agreement-review-muted {\n  font-size: var(--font-size-caption-md);\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n.agreement-review-sidebar {\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.agreement-review-page .rcti-agreement-card h2 {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-review-page .rcti-agreement-card label {\n  font-size: var(--font-size-body-sm);\n}\n.agreement-review-page input[readonly],\n.agreement-review-page textarea[readonly] {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.agreement-review-page textarea[readonly] {\n  resize: none;\n  line-height: 1.6;\n}\n.agreement-review-note {\n  display: grid;\n  gap: var(--space-2);\n  padding: var(--space-4);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-caption-md);\n  line-height: 1.5;\n}\n.agreement-review-page .agreement-review-before .rcti-consent {\n  display: flex;\n  gap: var(--space-3);\n  align-items: flex-start;\n  font-weight: var(--font-weight-regular);\n}\n.agreement-review-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  border-top: 1px solid var(--border-default);\n  padding-top: var(--space-4);\n}\n@media (max-width: 1100px) {\n  .agreement-review-columns {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .agreement-review-paper {\n    padding: var(--space-5);\n  }\n  .agreement-review-page .agreement-review-document-heading h2 {\n    font-size: 23px;\n  }\n  .agreement-review-parties {\n    grid-template-columns: 1fr;\n    gap: var(--space-5);\n  }\n  .agreement-review-footer > button {\n    width: 100%;\n  }\n  .agreement-review-document-bar {\n    flex-wrap: wrap;\n  }\n}\n.agreement-review-paper .agreement-clause p,\n.agreement-review-paper .agreement-review-scope p,\n.agreement-review-acknowledgement > p:not(.agreement-review-muted),\n.agreement-review-pending > p:first-of-type {\n  color: var(--text-primary);\n}\n.agreement-review-acknowledgement .rcti-saved-signature img {\n  max-height: 100px;\n}\n/* One formal agreement presentation for buyer preview and supplier records. */\n.rcti-designed .rcti-agreement-document.agreement-contract-document {\n  padding: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n.agreement-contract-document .agreement-review-document-heading h2 {\n  margin: 0;\n  font-size: 26px;\n  line-height: 1.3;\n  letter-spacing: -0.39px;\n  font-weight: var(--font-weight-semibold);\n}\n.agreement-contract-document .agreement-review-brand {\n  color: var(--interactive-default);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-contract-document .agreement-review-parties h3 {\n  margin: 0;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.55px;\n  color: var(--text-secondary);\n}\n.agreement-contract-document .agreement-review-muted {\n  font-size: var(--font-size-caption-md);\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n.agreement-contract-document .agreement-review-acknowledgement h3 {\n  margin: 0;\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-contract-document .agreement-review-pending h3 {\n  margin: 0;\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  color: var(--warning-text);\n}\n.agreement-contract-document .agreement-contract-status {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-review-email-card {\n  display: grid;\n  gap: var(--space-4);\n  padding: var(--space-5);\n  background: var(--surface-secondary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-agreements__content\n  .agreement-review-email-card\n  .agreement-email-preview-cta:disabled {\n  justify-self: start;\n  background: var(--interactive-disabled);\n  color: var(--on-interactive-disabled);\n  border: 1px solid var(--border-default);\n  cursor: not-allowed;\n  opacity: 1;\n  box-shadow: none;\n}\n@media (max-width: 1100px) {\n  .rcti-designed .agreement-public-workspace {\n    grid-template-columns: 1fr;\n  }\n  .agreement-public-workspace > .rcti-agreement-document,\n  .agreement-public-workspace > form,\n  .agreement-public-workspace > .rcti-public-controls {\n    grid-column: 1;\n    grid-row: auto;\n  }\n}\n@media (max-width: 600px) {\n  .agreement-contract-document .agreement-review-document-heading h2 {\n    font-size: 23px;\n  }\n}\n@media print {\n  .agreement-public-workspace {\n    display: block !important;\n  }\n  .agreement-public-workspace > form,\n  .agreement-public-workspace > .rcti-public-controls {\n    display: none !important;\n  }\n  .agreement-contract-document {\n    border: 0 !important;\n  }\n}\n.agreement-contract-document .rcti-agreement-badge {\n  justify-self: start;\n}\n.agreement-public-workspace > form > p,\n.agreement-public-workspace > .rcti-public-controls p,\n.rcti-agreements--public .rcti-design-heading p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.agreement-signature-sections { display: contents; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
